/** Mock lottery data (design prototype) */

export const MOCK_GAME_META = {
  nextDraw: 'Fri, Apr 24',
  nextJackpot: 212_000_000,
  rollover: 4,
};

export interface DrawRow {
  date: string;
  main: number[];
  bonus: number[];
  jackpot: number;
  winners: number;
  winnerLoc?: string;
}

export const DRAWS: DrawRow[] = [
  { date: 'Tue, Apr 21', main: [7, 14, 23, 31, 42], bonus: [9], jackpot: 188_000_000, winners: 0 },
  { date: 'Fri, Apr 17', main: [3, 18, 26, 33, 49], bonus: [14], jackpot: 172_000_000, winners: 0 },
  {
    date: 'Tue, Apr 14',
    main: [11, 19, 27, 38, 44],
    bonus: [2],
    jackpot: 156_000_000,
    winners: 1,
    winnerLoc: 'Austin, TX',
  },
  { date: 'Fri, Apr 10', main: [5, 16, 22, 35, 41], bonus: [17], jackpot: 142_000_000, winners: 0 },
  { date: 'Tue, Apr 7', main: [2, 13, 24, 29, 47], bonus: [11], jackpot: 128_000_000, winners: 0 },
  {
    date: 'Fri, Apr 3',
    main: [8, 15, 28, 36, 45],
    bonus: [6],
    jackpot: 114_000_000,
    winners: 1,
    winnerLoc: 'Reno, NV',
  },
  { date: 'Tue, Mar 31', main: [4, 17, 25, 32, 48], bonus: [19], jackpot: 98_000_000, winners: 0 },
  { date: 'Fri, Mar 27', main: [9, 20, 30, 37, 43], bonus: [5], jackpot: 85_000_000, winners: 0 },
];

export interface FreqRow {
  n: number;
  count: number;
}

export const FREQUENCY: FreqRow[] = (() => {
  const arr: FreqRow[] = [];
  for (let n = 1; n <= 49; n++) {
    let v = 18 + Math.round(Math.sin(n * 1.3) * 3) + (n % 7 === 0 ? 4 : 0);
    if ([7, 23, 42, 14, 31].includes(n)) v += 6;
    if ([1, 48, 6, 22, 39].includes(n)) v -= 6;
    arr.push({ n, count: Math.max(6, v) });
  }
  return arr;
})();

export const JACKPOT_TREND = [72, 85, 98, 114, 128, 142, 156, 172, 188, 212];

export const OVERDUE = [
  { n: 6, days: 52 },
  { n: 21, days: 48 },
  { n: 39, days: 44 },
  { n: 1, days: 41 },
  { n: 48, days: 39 },
];

export interface PairingRow {
  a: number;
  b: number;
  count: number;
  lift: number;
}

export const PAIRINGS: PairingRow[] = [
  { a: 7, b: 23, count: 14, lift: 2.3 },
  { a: 14, b: 31, count: 12, lift: 2.1 },
  { a: 23, b: 42, count: 11, lift: 1.9 },
  { a: 11, b: 27, count: 10, lift: 1.8 },
];

export interface TicketRow {
  id: string;
  main: number[];
  bonus: number[];
  draw: string;
  status: 'pending' | 'lost' | 'won-small';
  cost: number;
  prize?: number;
}

export const MY_TICKETS: TicketRow[] = [
  { id: 't1', main: [7, 14, 23, 31, 42], bonus: [9], draw: 'Fri, Apr 24', status: 'pending', cost: 2 },
  { id: 't2', main: [3, 11, 19, 27, 38], bonus: [14], draw: 'Fri, Apr 24', status: 'pending', cost: 2 },
  { id: 't3', main: [5, 16, 22, 35, 41], bonus: [17], draw: 'Fri, Apr 10', status: 'lost', cost: 2 },
  { id: 't4', main: [4, 17, 25, 32, 48], bonus: [19], draw: 'Tue, Mar 31', status: 'won-small', prize: 12, cost: 2 },
];

export const RULE_PRESETS = [
  {
    id: 'birthday',
    name: 'Birthday',
    desc: 'Ticket must include your birthday month and day as drawn numbers.',
    icon: 'sparkle' as const,
  },
  { id: 'hot', name: 'Hot numbers', desc: 'At least N main picks from the hottest pool in the window.', icon: 'flame' as const },
  { id: 'cold', name: 'Cold numbers', desc: 'At least N main picks from the coldest pool in the window.', icon: 'ice' as const },
  { id: 'overdue', name: 'Overdue numbers', desc: 'At least N mains that have been absent for several draws.', icon: 'clock' as const },
  { id: 'odd-even', name: 'Odd/Even balance', desc: 'Lock in a 3:2 or 2:3 odd-to-even ratio.', icon: 'dice' as const },
  { id: 'spread', name: 'Spread', desc: 'Spread picks across low-to-high number areas.', icon: 'stats' as const },
] as const;

export type RulePreset = (typeof RULE_PRESETS)[number];

export const SMART_PICK = {
  main: [7, 14, 23, 31, 42],
  bonus: [9],
  confidence: 0.74,
  basis: [
    { label: 'Hot streak', weight: 40 },
    { label: 'Cold mix', weight: 30 },
    { label: 'Odd/even 3:2', weight: 20 },
    { label: 'Spread check', weight: 10 },
  ],
};

export function formatUsd(n: number): string {
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(0)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n}`;
}
